import React from 'react';
import { Skeleton } from '@mui/material';
import { DetailsCard, DetailsContainer, DetailsGrid } from './ProjectDetailsStyles';

const ProjectDetailsSkeleton = () => {
  return (
    <DetailsContainer>
      <Skeleton variant="text" width={120} height={36} sx={{ mb: 3 }} />
      
      <DetailsCard>
        <Skeleton variant="text" width="60%" height={40} />
        <Skeleton variant="text" width="30%" height={24} sx={{ mb: 2 }} />
      </DetailsCard>

      <DetailsCard>
        <Skeleton variant="text" width="40%" height={32} sx={{ mb: 2 }} />
        <DetailsGrid>
          {[1, 2, 3, 4].map((n) => (
            <Skeleton key={n} variant="rectangular" height={200} />
          ))}
        </DetailsGrid>
      </DetailsCard>

      <DetailsCard>
        <Skeleton variant="text" width="40%" height={32} sx={{ mb: 2 }} />
        <DetailsGrid>
          {[1, 2, 3, 4, 5, 6].map((n) => (
            <div key={n} className="detail-item">
              <Skeleton variant="text" width="60%" />
              <Skeleton variant="text" width="100%" />
            </div>
          ))}
        </DetailsGrid>
      </DetailsCard>

      <DetailsCard>
        <Skeleton variant="text" width="40%" height={32} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" height={300} />
      </DetailsCard>
    </DetailsContainer>
  );
};

export default ProjectDetailsSkeleton;